/* ===== RAGE FULLSCREEN OVERLAY JS =====
   - MutationObserver su Details-menu-drawer-container[open]
   - Scramble effect sulle voci del menu (stesso del Rage Nav)
   - Zero modifiche a file nativi Shopify
   ======================================= */

(function() {
  var RAGE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%&';

  function rageScramble(el, original) {
    var count = 0;
    var interval = setInterval(function() {
      el.textContent = original.split('').map(function(char) {
        return char === ' ' ? ' ' : RAGE_CHARS[Math.floor(Math.random() * RAGE_CHARS.length)];
      }).join('');
      count++;
      if (count > 10) {
        clearInterval(interval);
        el.textContent = original;
      }
    }, 60);
  }

  function initOverlayScramble() {
    var links = document.querySelectorAll('.rage-overlay__link');
    links.forEach(function(link) {
      var textEl = link.querySelector('.rage-overlay__text');
      if (!textEl) return;
      var original = textEl.getAttribute('data-text');

      link.addEventListener('mouseenter', function() {
        rageScramble(textEl, original);
      });

      link.addEventListener('touchstart', function() {
        rageScramble(textEl, original);
      }, { passive: true });
    });
  }

  function openOverlay() {
  var overlay = document.getElementById('rage-overlay');
  if (!overlay) return;
  overlay.setAttribute('aria-hidden', 'false');

  // Anima i boxes SVG in sequenza casuale
  var paths = Array.from(overlay.querySelectorAll('.rage-overlay__svg path'));
  
  // Shuffle casuale
  paths.sort(function() { return Math.random() - 0.5; });
  
  // Mostra overlay subito ma ancora invisibile
  overlay.classList.add('is-open');
  
  // Reset tutti i path
  paths.forEach(function(path) {
    path.style.opacity = '0';
    path.style.transition = 'none';
  });

  // Anima in sequenza con delay crescente
  paths.forEach(function(path, i) {
    setTimeout(function() {
      path.style.transition = 'opacity 0.15s ease';
      path.style.opacity = '1';
    }, i * 30);
  });

  // Scramble voci dopo che i box sono apparsi
  var totalDelay = paths.length * 30 + 100;
  var links = overlay.querySelectorAll('.rage-overlay__text');
  links.forEach(function(textEl) {
    var original = textEl.getAttribute('data-text');
    setTimeout(function() {
      rageScramble(textEl, original);
    }, totalDelay);
  });
}

function closeOverlay() {
  var overlay = document.getElementById('rage-overlay');
  if (!overlay) return;

  // Anima i boxes SVG in sequenza casuale inversa
  var paths = Array.from(overlay.querySelectorAll('.rage-overlay__svg path'));
  paths.sort(function() { return Math.random() - 0.5; });

  paths.forEach(function(path, i) {
    setTimeout(function() {
      path.style.transition = 'opacity 0.15s ease';
      path.style.opacity = '0';
    }, i * 20);
  });

  // Nasconde overlay dopo animazione
  var totalDelay = paths.length * 20 + 200;
  setTimeout(function() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
  }, totalDelay);
}


  function initMutationObserver() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (!drawer) {
      // Riprova dopo 500ms se il drawer non è ancora nel DOM
      setTimeout(initMutationObserver, 500);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (drawer.hasAttribute('open')) {
            openOverlay();
          } else {
            closeOverlay();
          }
        }
      });
    });

    observer.observe(drawer, { attributes: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initOverlayScramble();
    initMutationObserver();
    // Close button
var closeBtn = document.getElementById('rage-overlay-close');
if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    window.location.href = '/';
  });
}

  });

})();
